import { render, staticRenderFns } from "./PayDay.vue?vue&type=template&id=28310f7a"
import script from "./PayDay.vue?vue&type=script&lang=js"
export * from "./PayDay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports